/**
 * Pure mapping helpers between loaded settings and their update payloads.
 */
import type { SettingsUpdate, VersionedSettings } from '../model/settingsTypes';

/**
 * Project a loaded settings resource into its update request by dropping the
 * server-managed audit fields (`updatedAt` / `updatedBy`) while keeping the
 * `version` (required for optimistic-locking) and every body field.
 */
export function toSettingsUpdate<T extends VersionedSettings>(settings: T): SettingsUpdate<T> {
  const next = { ...settings } as Record<string, unknown>;
  delete next.updatedAt;
  delete next.updatedBy;
  return next as SettingsUpdate<T>;
}
